export default __webpack_public_path__ + "static/media/godrej3xCropped.f658798c.png";